import SelectionShelf from "./-selectionShelf";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/goods/selectionShelf")({
  staticData: {
    menuLabel: "选品上架",
    showInMenu: true,
    menuGroup: "/goods",
    menuOrder: 3,
  },
  component: SelectionShelf,
});
